import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface GetAllEventsForCSVResponse {
  title: string;
  days: Array<string>;
  startTime: string;
  endTime: string;
  location?: {
    _id?: string;
    fieldName?: string;
  };
  duration: number;
  startDate: string;
  endDate: string;
  maxSize: number;
  oneTime: boolean;
  registrationFeeAmount: number;
  description: string;
  startAge: number;
  endAge: number;
  room: string;
  instructor: Array<string>;
  tags: Array<string>;
  group: Array<string>;
  policyGroup: Array<string>;
}

export const getAllEventsForCSVAPI = async () => {
  const response = await baseAPI.get<Array<GetAllEventsForCSVResponse>>(
    `/events/studio/all/csv`,
  );
  return response.data;
};

export const getAllEventsForCSVQueryOptions = (enabled: boolean) =>
  queryOptions({
    queryKey: [KEYS.EVENTS_CSV],
    queryFn: getAllEventsForCSVAPI,
    enabled: enabled,
  });

export const useGetAllEventsForCSV = ({ enabled }: { enabled: boolean }) => {
  return useQuery({
    ...getAllEventsForCSVQueryOptions(enabled),
  });
};
